import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getRoles = state => (state.roleManagement);
export const getFeatures = state => (state.features);
export const getUsers = state => (state.users)

/***************************** Subroutines ************************************/

function * fetchRoles() {
  try {
    const roles = yield call(Api.fetchRoles);
		yield put(Actions.initializeRoles(roles))
  }
  catch(e) {
    yield put({
    	type : ActionTypes.FETCH_CLIENTS_FAILED,
    	payload : {
    	 	message : e.message, status : e.status
    	 }
    })
  }
}

function * addRole(action) {
	try {
		let users = yield select(getUsers)
		yield put(Actions.toggleInitFlag(true))
		if(users.proxy_account !== null)
			yield put(Actions.sendSocketEmit({...action.payload, proxy_account : users.proxy_account}, 'add-role'))
		else 
			yield put(Actions.sendSocketEmit(action.payload, 'add-role'))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : ex.message}))
	}
}

function * addRoleSuccess(action) {
	try {
		let users = yield select(getUsers)
		if(users.user.is_admin && users.proxy_account != null) {
			yield put(Actions.setTmpUserRoles([...users.tmp_user_roles, action.payload.role]))
		}
		else {
			yield put(Actions.addRoleToState(action.payload.role))
		}
	}
	catch(ex) {
		yield put(Actions.notify({message : ex.message || ex}))
		yield put(Actions.toggleInitFlag(false))
	}
}

function * addRoleFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message}))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		console.log('Add role failed error : ', ex)
	}

}

function * deleteRole(action) {
	try {
		let users = yield select(getUsers)
		yield put(Actions.toggleInitFlag(true))
		let params = {role_id : action.payload._id, account_id : action.payload.account};
		yield put(Actions.hideDeleteRoleModal());
		yield put(Actions.sendSocketEmit(params, 'delete-role'))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(e) {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : e.message}))
	}
}

function * deleteRoleSuccess(action) {
	try {
		let users = yield select(getUsers)
		if(users.user.is_admin && users.proxy_account != undefined) {
			let new_roles = users.tmp_user_roles.filter(r => r._id !== action.payload.role_id)
			yield put(Actions.setTmpUserRoles(new_roles))
		}
		else {
			yield put(Actions.deleteRoleFromState(action.payload.role_id))
		}
	}
	catch(ex) {
		yield put(Actions.notify({message : ex.message || ex}))
	}
}

function * deleteRoleFailed(action) {
	try {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : action.payload.message}))
	}
	catch(ex) {
		console.log('Delete role failed error : ', ex)		
	}
}

function * enableFeatures(action) {
	try {
		let users = yield select(getUsers)
		let current_role = (yield select(getRoles)).selectedRole;
		yield put(Actions.addFeatureToRole(current_role, action.payload))
		if(users.proxy_account !== null) {
			yield put(Actions.sendSocketEmit({
		    	role_id : current_role, 
		    	features : action.payload,
		    	proxy_account : users.proxy_account
		    }, 'enable-feature'))
		}
		else {
			yield put(Actions.sendSocketEmit({
		    	role_id : current_role, 
		    	features : action.payload
		    }, 'enable-feature'))
		}
	}
	catch (ex) {
		console.log('ERROR ', ex)
	}
}

function * enableFeatureSuccess(action) {
	try {
		let features_state = yield select(getFeatures)
		yield put(Actions.updateRole(action.payload.role))
	}
	catch(ex) {
		console.log('ERROR ', ex.message ? ex.message : ex)
	}
}

function * enableFeatureFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message}))
	}
	catch(ex) {
		console.log('Enable feature failed error', ex.message ? ex.message : ex)
	}
}

function * disableFeatures(action) {
	try {
		let users = yield select(getUsers)
		let current_role = (yield select(getRoles)).selectedRole;
		yield put(Actions.removeFeatureFromRole(current_role, action.payload))
		if(users.proxy_account !== null) {
			yield put(Actions.sendSocketEmit({
		    	role_id : current_role, 
		    	features : action.payload,
		    	proxy_account : users.proxy_account
		    }, 'disable-feature'))
		}
		else {
			yield put(Actions.sendSocketEmit({
		    	role_id : current_role, 
		    	features : action.payload
		    }, 'disable-feature'))
		}
	}
	catch(ex) {
		console.log('ERROR ', ex.message ? ex.message : ex)
	}
}

function * disableFeatureSuccess(action) {
	try {
		let features_state = yield select(getFeatures)
		yield put(Actions.updateRole(action.payload.role))
	}
	catch(ex) {
		console.log('ERROR ', ex.message ? ex.message : ex)
	}
}

function * disableFeatureFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message}))
	}
	catch(ex) {
		console.log('Disable feature failed error', ex)
	}
}

function * handleClickRole(action) {
	try {
		let roles_state = yield select(getRoles)
		if(!roles_state.showFeatures) {
			yield put(Actions.toggleShowFeatures(true))
		}
		yield put(Actions.changeSelectedRole(action.payload))
		let current_role = roles_state.roles.find(r => r._id === action.payload)
		yield put(Actions.updateFeaturesOwnerType('Role'))
	}
	catch(ex) {
		console.log('ERROR ', ex.message ? ex.message : ex)
	}
}

function * editRoleFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message || action.payload}))
	}
	catch(ex) {
		console.log(ex)
	}
}

function * editRoleFailedCustom(action) {
	try {
		yield put(Actions.updateRole(action.payload.role))
	}
	catch(ex) {
		console.log(ex)
	}
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* rolesWatcher() {
  yield* [
    takeEvery(ActionTypes.BEGIN_INIT_ROLES, fetchRoles),
    takeEvery(ActionTypes.BEGIN_DELETE_ROLE, deleteRole),
    takeEvery(ActionTypes.BEGIN_ADD_ROLE, addRole),
    takeEvery(ActionTypes.ADD_ROLE_SUCCESS, addRoleSuccess),
    takeEvery(ActionTypes.ADD_ROLE_FAILED, addRoleFailed),
    takeEvery(ActionTypes.DELETE_ROLE_SUCCESS, deleteRoleSuccess),
    takeEvery(ActionTypes.DELETE_ROLE_FAILED, deleteRoleFailed),
    takeEvery(ActionTypes.BEGIN_ENABLE_FEATURES, enableFeatures),
    takeEvery(ActionTypes.ENABLE_FEATURE_SUCCESS, enableFeatureSuccess),
    takeEvery(ActionTypes.ENABLE_FEATURE_FAILED, enableFeatureFailed),
    takeEvery(ActionTypes.BEGIN_DISABLE_FEATURES, disableFeatures),
    takeEvery(ActionTypes.DISABLE_FEATURE_SUCCESS, disableFeatureSuccess),
    takeEvery(ActionTypes.DISABLE_FEATURE_FAILED, disableFeatureFailed),
    takeEvery(ActionTypes.HANDLE_CLICK_ROLE, handleClickRole),
    takeEvery(ActionTypes.EDIT_ROLE_FAILED, editRoleFailed),
    takeEvery(ActionTypes.EDIT_ROLE_FAILED_C, editRoleFailedCustom)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/roleManagement.js